import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import About from './components/About';
import Home from './components/Home';
import Notestate from './context/notes/Notestate';
import Signup from './components/Signup';
import Login from './components/Login';
function App() {
  return (
    <>
    <Notestate>
      <BrowserRouter>
      <Navbar/>
      <div className='container'>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login/>} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
      </div>
    </BrowserRouter>
    </Notestate>
    </>
  );
}

export default App;
